import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
    Loading, Error, useGetOne, useUpdate, useNotify,
} from 'react-admin';

import Form from './edit-image-form';

const EditImage = (props) => {
    const { imageId, onUpdated, onCancel } = props;

    const { data, isLoading, error } = useGetOne('images', { id: imageId });
    const [update, { isPending: updating }] = useUpdate();
    const notify = useNotify();

    const handleSubmit = useCallback((values) => {
        update(
            'images',
            { id: imageId, data: values },
            {
                onSuccess(data) {
                    onUpdated(data);
                },
                onError(error) {
                    notify(error.message, { type: 'error' });
                },
            },
        );
    }, [update, notify, onUpdated, imageId]);

    if (isLoading) return <Loading />;
    if (error) return <Error error={error} errorInfo={{ componentStack: null }} />;
    if (!data) return null;

    return (
        <Form image={data} updating={updating} onCancel={onCancel} onSubmit={handleSubmit} />
    );
};

EditImage.propTypes = {
    imageId: PropTypes.number.isRequired,
    onCancel: PropTypes.func.isRequired,
    onUpdated: PropTypes.func.isRequired,
};

export default EditImage;
